await themeComponent(theme.components['mc-element'], false);

class McOffcanvas extends McElement {
    constructor(){
        super();
    }

    connectedCallback(){
        this.drawer = this.querySelector('.drawer');
        this.drawers = this.drawer.querySelectorAll('mc-drawer');
        this.addEventListener('click', () => {
            this.deactivate();
        })
        this.drawer.addEventListener('click', (e) => {
            e.stopPropagation();
        })
    }

    afterClose = () => {
        document.querySelector('body').classList.remove('noscroll');
        if(this.drawers){
            this.drawers.forEach(drawer => {
                drawer.deactivate();
            });
        }
        if(this.dataset.followme != undefined && this.references){
            this.references.forEach((reference) => {reference.deactivate();});
        }
    }
    afterOpen = (attempts = 0) => {
        document.querySelector('body').classList.add('noscroll');
        if(this.dataset.followme != undefined){
            if(attempts >= 10){ 
                console.log('The dev will seriously consider pining for the fjords if this shows up again...\n', this);
                return;
            }
            if(this.references == undefined){
                setTimeout(() => {this.afterOpen(attempts + 1)});
                return;
            }
            else{
                this.references.forEach((reference) => {reference.activate();});
            }
        }
        if (this.dataset.justme != undefined) {

            this.parentElement.querySelectorAll("mc-offcanvas").forEach((canvas) => {
                if (canvas !== this) {
                    canvas.deactivate();
                }
            });

            // Check if any panels are now active
            const anyActive = this.parentElement.querySelectorAll("mc-offcanvas.mc-active").length > 0;

            document.body.classList.toggle('noscroll', anyActive);
        }
    }
}

if(!window.customElements.get('mc-offcanvas')){
    window.customElements.define('mc-offcanvas', McOffcanvas);
}
window.McOffcanvas = McOffcanvas;